import { makeStyles } from "@mui/styles"

// @ts-ignore
export const useStyles = makeStyles(({ typography }) => ({
// @ts-ignore
    root: ({ height }) => ({
      backgroundColor: "#f1f3f4 !important",
      borderRadius: "4px",

      "& input.MuiInputBase-input.MuiFilledInput-input": {
        paddingBottom: "0 !important",
      },

      "& span.MuiAutocomplete-tag": {
        color: "rgba(0,0,0,.6)",
      },

      "& .MuiChip-label.MuiChip-labelMedium": {
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden",
        maxWidth: "150px !important"
      },

      "& .MuiInputBase-root.MuiFilledInput-root": {
        background: "#f1f3f4 !important",
        height: "auto",
        minHeight: "4.4rem"
      },

      "& input": {
        paddingTop: "0 !important",
        "&[value='']": {
          "&:focus": {
            padding: "1.1rem 0 !important"
          },
        }
      },

      height
    }),

    groupLabel: {
      font: {
        size: typography.pxToRem(14),
        weight: 400
      },
      paddingTop: 12
    },

    groupUl: {
      borderBottom: [[1, "solid", "#efefef"]],
      borderTop: [[1, "solid", "#efefef"]]
    },

    listbox: {
      "& li:last-child": {
        "& ul": { borderBottom: "none" }
      },
      "&.MuiAutocomplete-listbox": {
        "& .MuiAutocomplete-option": {
          minHeight: "4.6rem",

          "&.Mui-focused": { backgroundColor: "#efefef" },
          "&:first-child": {
            borderTop: "none"
          },
          "&[aria-selected='true']": {
            "&.Mui-focused": { backgroundColor: "#efefef" },
            backgroundColor: "#efefef"
          }
        },
        maxHeight: 316,
        paddingTop: 0
      },
      marginTop: 20
    },

    paper: {
      "&.MuiAutocomplete-paper": {
        marginTop: 4
      },
      fontSize: typography.pxToRem(14),
      padding: 0
    },

    popper: {
      fontSize: typography.pxToRem(14)
    }

  })
)

